function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9 37.807c0 8.192 8.73 14.833 19.5 14.833S48 45.999 48 37.807c0-4.096-2.183-7.804-5.711-10.489-7.16-6.76-13.29-11.267-10.29-23.133-5 3.956-3.708 10.559-4.352 10.702-.217.09-.647-5.758-3.647-9.713 2 14.833-5 17.8-9.289 22.143C11.601 30.468 9 33.71 9 37.808z",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32 15.063c3.681 10.072 18.267 26.588 0 37.083M23.794 15.063c-3 9.889-15 25.711 0 37.083M30 15.063c4.059 18.657 3.941 30.426 0 35.698M27.011 15.063c-4.059 18.657-3.941 30.426 0 35.698M32 14.865c-3 .989-5 .989-8.206 0M32 14.865c-3 .989-5 .989-8.206 0"
}), /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M33 51.651c-3-.989-6.794-.989-10 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29 8.14C27.744 6.11 27.821 3.68 28 1.22c-1.288 2.28-2.88 5.237-2 7.614",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28 52.64v1.86M24 52.146l-1 1.978M32 52.146l.533 1.978"
})));

var SvgOnion = function SvgOnion(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOnion, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Onion.e26ca450.svg";
export { ForwardRef as ReactComponent };